<template>
  <div class="pc-magazine">
    <!-- 院校头部面包屑部分 -->
    <BreadCrumb :data="breadcrumb" :title="'杂志列表管理'" />
    <StatisticalPanel
      :whichModule="'guihua'"
      :data="overallData"
    ></StatisticalPanel>
    <div class="pc-magazine-table">
      <NewMagazineTable />
    </div>
  </div>
</template>
<script>
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import NewMagazineTable from "./components/NewMagazineTable";

import {
magazineCount_Api
} from "../../../apis/magazine.api";
export default {
  components: {
    BreadCrumb,
    NewMagazineTable,
    StatisticalPanel,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "杂志列表", link: "/admin/newMagazine" },
      ];
    },
  },
  data() {
    return {
      overallData: {
        title: "杂志数据",
        count: [
          { name: "杂志数量", count: null }, { name: "文章数量", count: null },
        ],
        
      },
    };
  },
  created() {},
  mounted() {
    magazineCount_Api().then((res) => {
      this.$set(this.overallData.count[0], "count", res.data.magazine_count);
      this.$set(
        this.overallData.count[1],
        "count",res.data.article_count
      );
    });
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/guihua/newMagazine.vue